import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'additionnal_photos_non_related_to_questions'

export const dataPointDefinition = {
  retracedId: 'additionnal_photos_non_related_to_questions',
  name: '4. Are there any photos you would like to add to the verification that did not directly correspond to a question?',
  description:
    'On the online platform, Verifiers/Assessors are able to upload photos for each question. You must upload photos if they directly fit to the question. If there are photos that do not directly fit to a question, you may upload them here, using the online platform and using a word document to capture m',
  meta: {
    slcpMeta: {
      key: 'vd-e24',
      number: 'VD-VERI-25',
      dataType: 'string',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '',
      machineShowHide: '',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-e24', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34660,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
